import { useState, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { close, escudoEA, escudoFIE, escudoMinDef, menu } from "../assets";
import { navLinks } from "../constants";
import QRDownloadButton from "./QRDownloadButton"; // ✅ Importamos el botón

const Navbar = () => {
    const [active, setActive] = useState("Home");
    const [toggle, setToggle] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const controls = useAnimation();

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        controls.start({
            y: 0,
            opacity: 1,
            transition: { duration: 0.5, ease: "easeOut" }
        });
    }, [controls]);

    return (
        <motion.nav 
            initial={{ y: -100, opacity: 0 }}
            animate={controls}
            className={`${
                scrolled ? "bg-white/80 backdrop-blur-md shadow-sm py-4" : "bg-transparent py-6"
            } w-full flex justify-between items-center fixed top-0 left-0 z-[100] px-6 sm:px-16 transition-all duration-300`}
        >
            <div className="flex flex-row space-x-2 items-center">
                <img src={escudoFIE} alt="logoEA" className="h-[40px] md:h-[50px] object-contain hover:scale-110 transition-transform cursor-pointer"/>
                <img src={escudoEA} alt="logoEA" className="h-[40px] md:h-[50px] object-contain hover:scale-110 transition-transform cursor-pointer"/>
                <img src={escudoMinDef} alt="logoEA" className="h-[40px] md:h-[50px] object-contain hover:scale-110 transition-transform cursor-pointer"/>
                <span className="text-darkBlue font-poppins font-bold text-[18px] ml-2 hidden ss:block tracking-wider">VAE</span>
            </div>

            {/* Desktop menu */}
            <ul className="list-none sm:flex hidden justify-end items-center flex-1">
                {navLinks.map((nav, index) => (
                    <li
                        key={nav.id}
                        className={`font-poppins font-semibold cursor-pointer text-[16px] relative group ${
                            active === nav.title ? "text-secondary" : "text-slate-600"
                        } ${index === navLinks.length - 1 ? "mr-0" : "mr-10"} hover:text-secondary transition-colors`}
                        onClick={() => setActive(nav.title)}
                    >
                        <a href={`#${nav.id}`}>{nav.title}</a>
                        <span className={`absolute -bottom-1 left-0 w-0 h-[2px] bg-secondary transition-all duration-300 group-hover:w-full ${active === nav.title ? "w-full" : ""}`}></span>
                    </li>
                ))}
                {/* ✅ Botón QR agregado al final de la lista */}
                <li className="ml-10">
                    <QRDownloadButton />
                </li>
            </ul>

            {/* Mobile menu */}
            <div className="sm:hidden flex flex-1 justify-end items-center">
                <img
                    src={toggle ? close : menu}
                    alt="menu"
                    className="w-[28px] h-[28px] object-contain cursor-pointer"
                    onClick={() => setToggle(!toggle)}
                />

                <div
                    className={`${
                        !toggle ? "hidden" : "flex"
                    } p-6 glassmorphism absolute top-20 right-0 mx-4 my-2 min-w-[140px] rounded-xl sidebar z-[100]`}
                >
                    <ul className="list-none flex justify-end items-start flex-1 flex-col">
                        {navLinks.map((nav, index) => (
                            <li
                                key={nav.id}
                                className={`font-poppins font-medium cursor-pointer text-[16px] ${
                                    active === nav.title ? "text-secondary" : "text-dimWhite"
                                } ${index === navLinks.length - 1 ? "mb-0" : "mb-4"} hover:text-white transition-colors`}
                                onClick={() => {
                                    setActive(nav.title);
                                    setToggle(false);
                                }}
                            >
                                <a href={`#${nav.id}`}>{nav.title}</a>
                            </li>
                        ))}
                        {/* ✅ Botón QR agregado al menú móvil */}
                        <li className="mt-4">
                            <QRDownloadButton />
                        </li>
                    </ul>
                </div>
            </div>
        </motion.nav>
    );
};

export default Navbar;